<div class="head" [ngStyle]="{'padding-top':alerttop+'px'}"></div>
<!-- <best-sales *ngIf="displayBestSales"></best-sales> -->
<!-- <best-offers *ngIf="displayBestOffers"></best-offers> -->
<carte [header]="alerttop"></carte>